"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_PRODUCTION = process.env.NODE_ENV === 'production';
//# sourceMappingURL=environment.js.map